module.exports = __webpack_public_path__ + "img/maas_wrapbg4.83fd7e47.png";